import { IEnvironment } from '../../../environments/environment.interface';
import { GeoLocationData } from '../models/geo-location-data.model';

export enum AppActionsEnum {
  INIT_ERROR_HANDLER = 'INIT_ERROR_HANDLER',
  INIT_APP = 'INIT_APP',
  FETCH_LOCATION_DATA = 'FETCH_LOCATION_DATA',
  FETCH_LOCATION_DATA_ERROR = 'FETCH_LOCATION_DATA_ERROR',
  SET_LOCATION_DATA = 'SET_LOCATION_DATA',
}

export interface InitApp {
  type: AppActionsEnum.INIT_APP;
}

export interface IEnvironmentPayload {
  environment: IEnvironment;
}

export interface IErrorPayload {
  error: Error;
}

export interface ILocationPayload {
  location: GeoLocationData;
}

export interface InitErrorHandler {
  type: AppActionsEnum.INIT_ERROR_HANDLER;
  payload: IEnvironmentPayload;
}

export interface FetchLocationData {
  type: AppActionsEnum.FETCH_LOCATION_DATA;
}

export interface SetLocationData {
  type: AppActionsEnum.SET_LOCATION_DATA;
  payload: ILocationPayload;
}

export interface FetchLocationDataError {
  type: AppActionsEnum.FETCH_LOCATION_DATA_ERROR;
  payload: IErrorPayload;
}

// action creators
export const initApp = (): InitApp => ({
  type: AppActionsEnum.INIT_APP,
});

export const initErrorHandler = (
  environment: IEnvironment
): InitErrorHandler => ({
  type: AppActionsEnum.INIT_ERROR_HANDLER,
  payload: {
    environment,
  },
});

export const fetchLocationData = (): FetchLocationData => {
  return {
    type: AppActionsEnum.FETCH_LOCATION_DATA,
  };
};

export const setLocationData = (location: GeoLocationData): SetLocationData => {
  return {
    type: AppActionsEnum.SET_LOCATION_DATA,
    payload: {
      location,
    },
  };
};

export const fetchLocationDataError = (
  error: Error
): FetchLocationDataError => {
  return {
    type: AppActionsEnum.FETCH_LOCATION_DATA_ERROR,
    payload: {
      error,
    },
  };
};
